import { API, retryRequest } from 'src/services'
import { freezeItems } from './freezeItems'

let requisicaoEmAndamento = null

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
    carregadoSobDemanda: false
  },
  getters: {
    workLeaveJourneys (state) {
      const folgaJourneys = state.items.filter(i => i.kind === -1)
      const afastamentoJourneys = folgaJourneys.filter(i => {
        return !['Férias', 'Folga', 'Feriado', 'Dispensa'].includes(i.name)
      })
      return afastamentoJourneys
    },
    jornadasSemEspeciais (state) {
      const resultadoSemJornadasEspeciais = state.items.filter(jornada => {
        return jornada.justify === false && jornada.leaveJourney === false && jornada.vacationJourney === false
      })
      return resultadoSemJornadasEspeciais
    }
  },
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(payload)
      state.loading = false
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    },
    resetarItens (state) {
      state.items = []
      state.carregadoSobDemanda = false
    },
    carregadoSobDemanda (state, payload) {
      state.carregadoSobDemanda = payload
    }
  },
  actions: {
    async fetchItems ({ commit, state }, payload=null) {
      if (state.carregadoSobDemanda) {
        return state.items
      }

      if (requisicaoEmAndamento) {
        return requisicaoEmAndamento
      }

      commit('loading', true)

      requisicaoEmAndamento = retryRequest(API.journey.get, payload?.withParams)
        .then(result => {
          commit('saveItems', freezeItems(result.body.success))
          return state.items
        })
        .catch(erro => {
          commit('carregadoSobDemanda', false)
          throw erro
        })
        .finally(() => {
          commit('loading', false)
          requisicaoEmAndamento = null
        })

      return requisicaoEmAndamento
    }
  }
}
